<section class="main-section" [attr.isCollapsed]="isSideNavCollapsed ? '1' : '0'">
  <!-- start page content -->
  <div class="content">
    <ng-content></ng-content>
  </div>
  <!-- end page content -->
</section>
